import React from 'react';
import './EditDrugBoxPopup.css';
import Popup from '../../../components/popup/Popup';
import Card from '../../../components/card/Card';
import Label from '../../../components/label/Label';
import Button from '../../../components/button/Button';
import Input from '../../../inputs/input/Input';
import toasts from '../../../utils/toasts';
import models from '../../../model/models';
import FormTemplate from '../../../components/templates/formTemplates/FormTemplate';
import DeleteConfirmationPopup from '../../../components/deleteConfirmationPopup/DeleteConfirmationPopup';
import history from '../../../history';
import mainAPI from '../../../api/MainAPI';
import UniversalDropDown from '../../../components/universalDropDown/UniversalDropDown';
import TemperatureSensorPopup from "../../../popups/temperatureSensorPopup/TemperatureSensorPopup";
import PrimaryButton from "../../../components/primaryButton/PrimaryButton";
import userGroupSettingsManager from "../../../utils/UserGroupSettingsManager";
import {addTempSensor} from "../../../utils/tempSensorVerbage";

export default class EditDrugBoxPopup extends FormTemplate {
	constructor(props) {
		super(props);
		this.state = { 
			drug_box: this.props.drug_box,
			showTempSensorPopup: false
		};
	}
	componentDidMount() {
		this.getData()
	}
	getData = async () => {
		await userGroupSettingsManager.refresh();
		this.setState({loaded:true})
	}

	componentWillReceiveProps(nextProps, nextContext) {
		this.setState({ drug_box: nextProps.drug_box });
	}

	_save = async () => {
		if (!this.isValid()) return;

		let drug_box = this.getValue();
		let value = this.state.drug_box;
		for (let i in drug_box) {
			value[i] = drug_box[i];
		}
		if (value.barcode_id.length <= 3) {
			return toasts.show('Code must be longer than 3 characters');
		}
		value.central_supply = value.central_supply ? 1 : 0;
		let res = await models.drug_box.save(value);
		if (!res) return toasts.show('This code is taken');
		this.props.onClose();
	};

	_confirmArchive = () => {
		let value = this.getValue();
		this.setState({ value, showArchive: true });
	};

	_archiveBox = async () => {
		const {archived, reason} = await models.drug_box.archive(this.state.drug_box.id);
		if (archived) {
			this.setState({ showArchive: false });
			history.navigate('/units');
		}
		else {
			if (reason === 'ASSOCIATED_DRUGS') {
				toasts.show('Can not archive drug box. Transfer or use all drugs assigned to this drug box.', 5000);
			}
			else {
				toasts.show('Could not archive drug box');
			}
		}
	};

	_hideArchive = () => {
		this.setState({ showArchive: false });
	};

	_showTempSensorPopup = () => {
		if(!Boolean(userGroupSettingsManager.getSetting('bloodcomm_uuid'))){
			toasts.error("You need to add your organization ID in settings before you can add a sensor")
		}
		this.setState({ showTempSensorPopup: true });
	};

	_hideTempSensorPopup = () => {
		this.setState({ showTempSensorPopup: false });
		this.props.onClose();
	};

	render() {
		let drug_box = this.state.drug_box || {};
		return (
			<Popup show={this.props.show} onClose={this.props.onClose} className="g-edit-drug-box-popup">
				<DeleteConfirmationPopup
					show={this.state.showArchive}
					title="Archive"
					confirmation="Are you sure you want to archive this drug box?"
					onConfirm={this._archiveBox}
					onClose={this._hideArchive}
				/>
				<TemperatureSensorPopup
					show={this.state.showTempSensorPopup}
					drugBoxId={drug_box.id}
					onSensorAdded={(sensor) => {
						console.log('Sensor added:', sensor);
					}}
					onClose={this._hideTempSensorPopup}
				/>
				<Card>
					<Label larger black>
						Edit Drug Box
					</Label>
					<Label gray-medium>Code</Label>
					<Input value={drug_box.barcode_id} required ref={(ref) => (this.myRefs.barcode_id = ref)} />
					<Label gray-medium>Name</Label>
					<Input length={15} value={drug_box.name} required ref={(ref) => (this.myRefs.name = ref)} />
					<Label gray-medium>Unit</Label>
					<UniversalDropDown
						value={drug_box.unit_id}
						endpoint={mainAPI.unit.allWithoutBox}
						ref={(ref) => (this.myRefs.unit_id = ref)}
					/>
					{userGroupSettingsManager.getSetting('allow_temperature_sensor') && (
						<PrimaryButton onClick={this._showTempSensorPopup}>
							{addTempSensor(userGroupSettingsManager.getSetting('bloodcomm_uuid'))}
						</PrimaryButton>
					)}
					<div className="button-row">
						<Button color="white" bg="red" onClick={this._confirmArchive}>Archive</Button>
						<Button color="white" bg="blue" onClick={this._save}>
							Save
						</Button>
					</div>
				</Card>
			</Popup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/drugBoxDetailsPage/editDrugBoxPopup/EditDrugBoxPopup.jsx